const MAX_UPLOAD_SIZE = 4 * 1024 * 1024
const IMG_TYPE = ['image/png', 'image/jpeg', 'image/jpg'];
let isDrop = false;

const imageIsValid = el => {
  return isFile(el) && hasFile(el) && hasFileAllowedFormat(el) && hasFileAllowedSize(el)
}

const hasSisterImage = el => {
  return el.parentElement.querySelector('.js-image-to-update').getAttribute('src') !== ""
}

const anyImageHasSource = el => {
  const images = Array.from(el.closest('.project__drop-container').querySelectorAll('.js-image-to-update'))
  return !images.some( img => !!img?.getAttribute('src').length)
}

// list of valid validation rules the user can use
const validationRules = (el, rule) => {
  // required means: more than zero characters, can't be just whitespaces
  switch (rule) {
    case 'required':
      return el.value.length <= 0 || /^\s*$/.test(el.value)
    case 'email':
      return el.value.length <= 0 || !(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(el.value))
    case 'phone':
      return el.value.length <= 10 || el.value.length >= 17 || !(/^[+]?[\s./0-9]*[(]?[0-9]{1,4}[)]?[-\s./0-9]*$/g.test(el.value))
    case 'checkbox':
      return !el.checked
    case 'image':
      if (imageIsValid(el)) {
        return false
      } else if(!imageIsValid(el) && hasFile(el)) {
        return true
      } else if (!imageIsValid(el) && hasSisterImage(el)){
        return false
      }  else {
        return true
      }
    case 'at_least_one_image':
      return anyImageHasSource(el)
    case 'image_not_required':
      if (hasFile(el) && !imageIsValid(el)) {
        return true
      } else if(anyImageHasSource(el)){
        return false
      } else {
        return false
      }
    default:
      throw new Error('Wrong rule validation')
  }
}

const isCheckbox = el => el.type === 'checkbox';
const isFile = el => el.type === 'file';
const hasFile = el => el.files.length !== 0
const hasFileAllowedSize = el => el.files[0].size < MAX_UPLOAD_SIZE
const hasFileAllowedFormat = el => IMG_TYPE.includes(el.files[0].type)
const checkboxUiValidation = el => {
  const label = isCheckbox(el) && el.parentElement.querySelector('.afd-checkbox__label')
  isCheckbox(el) && el.checked
    ? label.classList.remove('kth-error-label')
    : label.classList.add('kth-error-label')
}

const imageUiValidation = el => {
  const dropArea = el.closest('.js-drop__area')
  const validationAlert = dropArea.querySelector('.kth-input-val.kth-input-val--false')
  if (!imageIsValid(el) && document.body.contains(validationAlert)) {
    dropArea.classList.add('project__drop-error')
  } else {
    dropArea.classList.remove('project__drop-error')
  }
}

const findErrorMessages = el => {
  let validationAlert = null;
  let validationErrorMessage = null;
  if (!isCheckbox(el)) {
    // clean sibling class from previous validations
    if (el.nextElementSibling !== null && el.nextElementSibling.classList.contains('kth-input-val')) {
      validationAlert = el.nextElementSibling;
      validationAlert.classList.remove('kth-input-val--true');
      validationAlert.classList.remove('kth-input-val--false');
      // if we have the error message element, then we assign the right DOM element
      if (validationAlert.nextElementSibling.classList.contains('kth-form__hint')) {
        validationErrorMessage = validationAlert.nextElementSibling;
      }
    } else {
      // we will need an element to put the alert
      validationAlert = document.createElement('div');
      validationAlert.classList.add('kth-input-val');
      // and also an element to put the error message
      validationErrorMessage = document.createElement('div');
      validationErrorMessage.classList.add('kth-input-tip', 'kth-form__hint');
    }
    isFile(el) && imageUiValidation(el)
  } else {
    checkboxUiValidation(el)
  }
  return { validationAlert, validationErrorMessage };
};

/**
   * Updates the UI (error/success messages and CTA status) after a validation is made on an
   * element of the form being validated.
   * @param {Object} validationElements object with HTMLElements to update to show error/success
   *                                    messages
   * @param {boolean} validationStatus true if validation is ok, false in the opposite case
   * @param {boolean} skipUI [false] true if you want avoid update validationElements, false in
   *                                 the opposite case. Useful to just update the CTA status.
*/

const actOnValidation = (validationElements, validationStatus, skipUI = false, el, onValidationCallback = null) => {
  const { validationAlert, validationErrorMessage } = validationElements;
  if (!skipUI && !isCheckbox(el)) {
    if (validationStatus === false) {
      // case when validation fails
      validationAlert.classList.add('kth-input-val--false');
      validationErrorMessage.classList.remove('afd-hide');
      let message = el.dataset.validationError;
      if (isFile(el) && hasFile(el)) {
        !hasFileAllowedSize(el) && hasFileAllowedFormat(el) 
        ? (message = el.dataset.maxSize)
        : (message = el.dataset.incorrectFormat)
        handleDropAreaUi(el, true)
      }
      validationErrorMessage.textContent = message;
    } else {
      // case when validation is successful
      validationAlert.classList.add('kth-input-val--true');
      validationErrorMessage.classList.add('afd-hide');
    }
  }
  // If is a Checkbox (Terms & Conditions)
  isCheckbox(el) && checkboxUiValidation(el)

  //if is a file check if is an image inside it
  isFile(el) && imageUiValidation(el)

  // if we have callback, we use it
  if (onValidationCallback) {
    onValidationCallback(el, validationStatus);
  }
};

//Action to perform validations in all fields 
const validateField = (el, validationRule, onValidationCallback) => {
  const validationElements = findErrorMessages(el);
  // now, perform validation
  actOnValidation(validationElements, !validationRules(el, validationRule), false, el, onValidationCallback);
  updateValidationUI(validationElements, el);
}

const updateValidationUI = (validationElements, el) => {
  const { validationAlert, validationErrorMessage } = validationElements;
  // insert validation elements if they are not already there
  if (!document.body.contains(validationAlert) && !isCheckbox(el)) {
    el.after(validationAlert);
    validationAlert.after(validationErrorMessage);
  }
  // If is a Checkbox (Terms & Conditions)
  isCheckbox(el) && checkboxUiValidation(el)

  // if is an image (profs add content)
  isFile(el) && imageUiValidation(el)
};

/**  on input, we just signal a validation that has passed. We don't update UI with
// errors on input because it's considered an UX practice that can lower conversion
// rates (see http://alistapart.com/article/inline-validation-in-web-forms). */
const actionsForValidate = (el, validationRule, onValidationCallback) => {
  const validationElements = findErrorMessages(el);
  if (!validationRules(el, validationRule)) {
    actOnValidation(validationElements, true, false, el, onValidationCallback); // force a success validation
    updateValidationUI(validationElements, el); 
    isFile(el) && readURL(el)
  } else {
    let skipUI = true
    isFile(el) && (skipUI = false)
    actOnValidation(validationElements, false, skipUI, el, onValidationCallback); // force a CTA update
    isDrop && updateValidationUI(validationElements, el);
  }
}

// Global events for open, close modal
const attachOpenModalEvent = removeImg => {
  removeImg.addEventListener('click', () => {
    const modalId = removeImg.dataset.modalid
    const modal = document.getElementById(`${modalId}`)
    modal && (modal.dataset.item = removeImg.dataset.remove)
    // Remove image and description and set the  UI Validation and configs 
    AFD.modals.open(`#${modalId}`);
    removeImg.removeEventListener('click', attachOpenModalEvent)
  })
}

const handleDelete = (deleteCollab, onValidationCallback) => {
  const modal = deleteCollab.closest('.project__modal')
  const file = document.querySelector(`.${modal.getAttribute('data-item')}`)
  const inputDeleteName = file.name.replace('[image]', '[delete]')
  const removeImg = file.closest('.js-drop__area').querySelector('.js-drop__remove')
  let inputDelete = file.parentElement.querySelector(`input[name="${inputDeleteName}"]`)
  const textarea = file.parentElement.closest('.project__drop--img').querySelector('.afd-textfield__textarea')
  if (inputDelete === null) {
    inputDelete = document.createElement('input')
    const attributes = {
      type: 'hidden',
      name: inputDeleteName,
    }

    Object.entries(attributes).forEach(([key, value]) => {
      inputDelete.setAttribute(key, value)
    });
    file.parentNode.append(inputDelete)
  }

  AFD.modals.closeNow(`#${modal.id}`);
  handleDropAreaUi(file, true)
  textarea.value = "";
  textarea.innerHTML = "";
  file.value = ""
  removeImg && removeImg.classList.add('project__hide')
  validateField(file, 'at_least_one_image', onValidationCallback)
  deleteCollab.removeEventListener('click', handleDelete)
}

const attachCloseModalEvent = (closeBtn) => {
  closeBtn.addEventListener('click', (event) => closeModal(event))

  const closeModal = event => {
    const modal = closeBtn.closest('.project__modal')
    AFD.modals.closeNow(`#${modal.id}`)
    event.stopPropagation();
  }
}

const handleRemoveCollabBehaviour = onValidationCallback => {
  const closeModals = document.querySelectorAll('.js-close-modal');
  const removeImages = document.querySelectorAll('.js-drop__remove')
  const deleteCollab = document.getElementById('js-delete-description');

  // Open modal for delete image
  removeImages?.forEach(attachOpenModalEvent)
  closeModals?.forEach(attachCloseModalEvent)
  //Activate the click for the listener
  deleteCollab?.addEventListener('click', () => handleDelete(deleteCollab, onValidationCallback))
}

//handles Drag and Drop for file
const handleUploads = (input, validationRule, onValidationCallback) => {
  const endDragEvents = ['dragend', 'dragleave']
  const dropArea = input.closest('.js-drop__area')
  const removeImg = dropArea.querySelector('.js-drop__remove')

  dropArea.addEventListener('dragover', e => {
    e.preventDefault()
    dropArea.classList.add('dragover')
  })

  // Leave or end the dragover
  endDragEvents.forEach(typeEvent => {
    dropArea.addEventListener(typeEvent, () => {
      dropArea.classList.remove('dragover')
    })
  })

  // Drop item in the area
  dropArea.addEventListener('drop', e => {
    e.preventDefault()
    // Preview Image uploaded droping the image
    if (e.dataTransfer.files.length) {
      input.files = e.dataTransfer.files
      dropArea.classList.remove('dragover')
      removeImg && removeImg.classList.remove('project__hide');
    }
    isDrop = true;
    actionsForValidate(input, validationRule, onValidationCallback)
  })
}

const handleDropAreaUi = (input, isDelete) => {
  const dropArea = input.closest('.js-drop__area')
  if (input.value !== "" && !isDelete) {
    dropArea.classList.add('project__drop-area-set')
  } else {
    const image = dropArea.querySelector('.js-image-to-update')
    const dropInfo = input.parentNode.querySelector('.project__drop-info')
    dropArea.classList.remove('project__drop-area-set')
    dropInfo.classList.remove('project__drop-info--hide', 'hide-it')
    image.classList.add('afd-hide');
    image.classList.remove('project__drop--img-preview')
    image.src = ""
  }
}

const setImageSource = (e, image, dropArea) => {
  image.setAttribute('src', e.target.result)
  dropArea.classList.add('project__drop-area-set');
  image.classList.remove('afd-hide');
  image.classList.add('project__drop--img-preview');
}

const readURL = input => {
  if (input.files?.length === 0) return false
  const reader = new FileReader()
  const dropArea = input.closest('.js-drop__area')
  const image = dropArea.querySelector('.js-image-to-update')
  const inputDeleteName = input.name.replace('[image]', '[delete]')
  const inputDelete = dropArea.querySelector(`input[name="${inputDeleteName}"]`)
  reader.onload = e => setImageSource(e, image, dropArea)
  reader.readAsDataURL(input.files[0])
  inputDelete?.remove()
}



/**
 * Add validation to an input element. It will add a green success or yellow
 * warning mark inside the put plus a validation error message depending on the
 * input status.
 *
 * @param {HTMLElement} el input to validate
 * @param {string} validationRule one of required, email, phone number.
 * @param {string} errorMessage error to show when validation fails. If no error is specified,
 *                              a data-validation-error element will be searched on el and used.
 * @callback onValidationCallback to be called after the validation gets performed. Receives the
 *                                validation DOMel and validation status
 */
const validateFormElement = (el, validationRule, errorMessage = null,
  onValidationCallback = null, ctaEl) => {
  /** Checking if @type {HTMLElement} is a checkbox or image so we can give a different UI validation. */

  // attach listeners to perform validation
  // on blur, we perform a full validation
   el.addEventListener('blur', () => validateField(el, validationRule, onValidationCallback));

  if (isFile(el)) {
    handleUploads(el, validationRule, onValidationCallback)
    el.addEventListener('change', () => { actionsForValidate(el, validationRule, onValidationCallback) });
  }

  el.addEventListener('input', actionsForValidate(el, validationRule, onValidationCallback));

  ctaEl.addEventListener('click', () => {
    const validationElements = findErrorMessages(el);
    actOnValidation(validationElements, !validationRules(el, validationRule), false, el, onValidationCallback);
    updateValidationUI(validationElements, el);
  })

  // Trigger click event on "Enter" key press
  el.addEventListener('keyup', (event) => {
    // Execute click event only if is not a Message Section
    if (event.keyCode === 13 && el.id !== 'verification_request_request_message')
      ctaEl.click()
  })
};

const toggleEnableBtn = (btn, status) => {
  if (!btn) return false

  if (status === 'enabled' ) {
    btn.classList.remove('afd-btn--not-allowed');
    btn.setAttribute('type', 'submit')
  } else {
    btn.classList.add('afd-btn--not-allowed');
    btn.setAttribute('type', 'button')
  }
}


/**
 * Validates the given form. You need to specify by hand which elements of the form to validate
 * and also the rules to use.
 *
 * @param {HTMLElement} formEl form to validate
 * @param {Object} options two attributes required: validations (object of elements to validate,
 *                         key is attr selector and value is rule to use) and cta (selector of CTA).
 */
const contentValidateForm = (formEl, options) => {
  const internalValidator = {};
  let initRemoveFile = false
  // logic to enable/disable the CTA button of the form
  const ctaEl = formEl.querySelector(options.cta);
  /** @type {onValidationCallback} */

  const checkForm = (attr, validationStatus) => {
    internalValidator[attr.id] = validationStatus;
    const formStatus = Object.values(internalValidator).reduce((t, status) => t && status, true);
    if (formStatus) {
      toggleEnableBtn(ctaEl, 'enabled')   
    } else {
      toggleEnableBtn(ctaEl, 'disabled')
    }
  };


  Object.entries(options.validations).forEach(([attr, rule]) => {
    const attrEl = formEl.querySelector(attr);
    if (attrEl) {
      internalValidator[attrEl.id] = false; // by default, is invalid  
      validateFormElement(attrEl, rule, null, checkForm, ctaEl);
      if (isFile(attrEl)) {
        attrEl.setAttribute('data-rule', rule)
        !initRemoveFile && handleRemoveCollabBehaviour(checkForm)
        initRemoveFile = true
      }
    }
  });
};

export { contentValidateForm };